import { TZDate } from '@date-fns/tz'
import { listReceptionCallHistories } from '@reception-web/common/api/app'
import { REDIAL_EXPIRED_TIME } from '@reception-web/common/consts'
import { format } from 'date-fns'
import useSWR from 'swr'

function isRedialTime(dateString: string) {
  return (
    new Date(dateString).getTime() + REDIAL_EXPIRED_TIME > new Date().getTime()
  )
}

export const useHistoryApi = ({ aosToken }: { aosToken: string | null }) => {
  const { data, error } = useSWR(
    aosToken ? `/aos/histories` : null,
    () =>
      listReceptionCallHistories(undefined, {
        headers: { Authorization: `Token ${aosToken}` },
      }).then((res) => res.data),
    {
      refreshInterval: 1000 * 5,
    }
  )

  const histories = data?.results?.map((history) => {
    const date = history.created ? new Date(history.created) : null
    let created = ''
    if (date && !isNaN(date.getTime())) {
      const jstDate = new TZDate(date, 'Asia/Tokyo')
      created = format(jstDate, 'MM/dd HH:mm') + ' (JST)'
    }

    let expiredRedial = true
    if (history.finished && isRedialTime(history.finished)) {
      expiredRedial = false
    } else if (history.timeouted && isRedialTime(history.timeouted)) {
      expiredRedial = false
    } else if (history.canceled && isRedialTime(history.canceled)) {
      expiredRedial = false
    }

    return {
      ...history,
      created,
      expiredRedial,
    }
  })

  return {
    data: histories,
    error,
  }
}
